export const pushDataObject = (dataObject: object) => {
  window.dataLayer = window.dataLayer || []

  window.dataLayer.push(dataObject)
}
